import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
// import { CaretSortIcon } from "@radix-ui/react-icons";
import { useHeaderTop } from "./hooks";
import { Skeleton } from "@/components/ui/skeleton";
import { Forms } from "@/types/form";
import { User } from "lucide-react";
import LogoWinelandPortal from "@/assets/logos/wineland-portal";

interface Props {
  vendor: Forms["Vendor"] | undefined;
}

const HeaderTop: React.FC<Props> = ({ vendor }) => {
  const { onProfile, onLogout, onLogo } = useHeaderTop();

  return (
    <div className="flex justify-center items-center gap-6 h-16 py-1 px-4">
      <div>

        <button onClick={onLogo} className="cursor-pointer">
          <LogoWinelandPortal className="h-6" />
        </button>
      </div>
      <div className="absolute right-8 flex gap-5">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="outline"
              className="focus-visible:ring-0 border-[#E4E4E7]"
            >
              <span className="flex items-center gap-2">
                {vendor ? (
                  <p className="font-medium text-sm ">{vendor.title}</p>
                ) : (
                  <Skeleton className="h-4 min-w-20" />
                )}
              </span>
              {/* <CaretSortIcon /> */}
            </Button>
          </DropdownMenuTrigger>
        </DropdownMenu>
        <DropdownMenu>
          <DropdownMenuTrigger asChild className="cursor-pointer">
            <div className="flex items-center justify-center w-8.5 h-8.5 rounded-full bg-gray-200">
              <User className="w-5 h-5 text-gray-600" />
            </div>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="min-w-36">
            <DropdownMenuGroup>
              <DropdownMenuItem onClick={onProfile}>Profile</DropdownMenuItem>
              <DropdownMenuItem onClick={onLogout}>Log out</DropdownMenuItem>
            </DropdownMenuGroup>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
};

export default HeaderTop;
